module.exports = __webpack_public_path__ + "static/2front-hasta-1-c4b437e8504dafada17426dee0b252cc.png";